import { styled } from '../../../providers/context/StyletronProvider/withStyletronProvider';

export const PillowImg = styled('img', {
  width: '100%',
});
